import React, { useState } from 'react';
import styles from './Gallery.module.css'; // optional: import your CSS styling

const Gallery = ({ images, imagesPerPage = 9 }) => {
  // State to track how many images are currently visible.
  const [visibleCount, setVisibleCount] = useState(imagesPerPage);

  // Load more images by increasing the count.
  const loadMore = () => {
    setVisibleCount(prevCount => prevCount + imagesPerPage);
  };

  // Slice the images array to only show the visible ones.
  const visibleImages = images.slice(0, visibleCount);

  return (
    <div className={styles.gallery}>
      <div className={styles.gallery_grid}>
        {visibleImages.map((image, index) => (
          <div key={index} className={styles.gallery_item}>
            <img
              src={image.src}
              alt={`Gallery image ${index + 1}`} //image.alt || 
              className={styles.gallery_image}
            />
          </div>
        ))}
      </div>
      {/* Show the Load More button if there are still images left */}
      {visibleCount < images.length && (
        <button className={styles.load_more} onClick={loadMore}>
          Load More
        </button>
      )}
    </div>
  );
};

export default Gallery;